export const HOST = 'https://harmony-hub-counselling-api.onrender.com'

// local : http://localhost:8080
// production : https://harmony-hub-counselling-api.zahinzul.com
// https://harmony-hub-counselling-api.onrender.com
//
